import React, { useEffect, useState } from "react";
import "./style.css";
import "../../../../style.css";
import Button from "../../../../shared/ui/inputs/classicButton.js";
import Description from "../../../client/components/description/description.js";
import CollectionTabs from "../CollectionTabs/CollectionTabs.js";
export default function Nav(props) {
    const [contactOpen, setContactOpen] = useState(false);
    const { collection } = props;
    useEffect(() => {
        document.querySelector(".collection-main-container").scrollTo({ top: 0 });
    }, [props.openedTab]);
    return (React.createElement("div", { className: "nav-container" },
        React.createElement("div", { className: "nav-collection-tabs-container" }, !collection.allowedImages && (React.createElement(CollectionTabs, { categories: collection.categories, onCategoryOpen: props.onTabOpen, openedCategory: props.openedTab }))),
        React.createElement("div", null, collection.content.contactData && (React.createElement(Button, { value: "contact", classNames: "client-nav-button", version: "alternative", onClick: () => setContactOpen(true) },
            React.createElement("span", null, "Kontakt"),
            React.createElement("img", { style: {}, about: "https://uxwing.com/ - super website", src: "../../assets/icons/contact-us.svg", height: "25" })))),
        contactOpen && (React.createElement(Description, { value: collection.content.contactData, onLeave: () => setContactOpen(false) }))));
}
